import { Component, Inject, Input, Output } from 'angular-ts-decorators';

import template from './pfm-pager.component.html';

@Component({
  selector: 'pfmPager',
  template,
})
export class PfmPagerComponent {
  public static $inject: ReadonlyArray<string> = [];

  @Input('=') public count: number;
  @Input('=') public currentPage: number;
  @Input() public pageSize: number;

  @Output() public pageAction: () => void;

  constructor(@Inject('$timeout') private $timeout: ng.ITimeoutService) {
  }

  public pages(): number[] {
    const pageCount: number = Math.ceil(this.count / this.pageSize);
    const pages: number[] = [];

    for (let i = 1; i <= pageCount; i++) {
      pages.push(i);
    }

    return pages;
  }

  public limitStart(): number {
    const numberOfVisiblePages = 3;
    return this.currentPage < numberOfVisiblePages ? 0 : this.currentPage - numberOfVisiblePages;
  }

  public setFirstPage() {
    this.setPage(1);
  }

  public setLastPage() {
    this.setPage(this.pages().length);
  }

  public setNextPage() {
    this.setPage(this.currentPage + 1);
  }

  public setPreviousPage() {
    this.setPage(this.currentPage - 1);
  }

  public isFirstPage(): boolean {
    return this.currentPage === 1;
  }

  public isCurrentPage(page: number): boolean {
    return this.currentPage === page;
  }

  public isLastPage(): boolean {
    return this.currentPage === this.pages().length;
  }

  private setPage(page: number) {
    if (this.currentPage === page) {
      return;
    }

    this.currentPage = page;
    this.$timeout(() => { this.pageAction(); });
  }
}
